import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { AppContext } from '../../AppProvider';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import Grid from '@material-ui/core/Grid';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../styles/typography';
import BOLStyles from './__styles__/BOL.styles';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import FormItemContainerStyles from '../../components/Global/Containers/__styles__/FormItemContainer.styles';
import { UNIT_ABBREVIATIONS, CURRENCY_SYMBOL } from '../../constants/constants';

import BOLItemInfo from './ItemInfo';

class UnitInfo extends Component {
  state = { isStackable: true, unitIsHazMat: false };

  static propTypes = {
    unit: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
  };

  componentDidMount() {
    const { unit } = this.props;

    this.setState({
      unitIsHazMat: this._isHazMat(unit),
      isStackable: !unit.doNotStack
    });
  }

  _isHazMat = unit => {
    const hazMatItem = _find(unit.shipmentItems, item => {
      return item.product.isHazMat;
    });

    return !_isEmpty(hazMatItem);
  };

  render() {
    const { unit, index, classes, t } = this.props;
    const { unitIsHazMat, isStackable } = this.state;

    return (
      <Fragment>
        <Grid
          container
          spacing={8}
          className={classnames(classes.unitBorder, classes.unitHeaderText)}
        >
          <Grid item xs={2}>
            <div className={classes.unitText}>
              {t('Unit')} {index + 1}:{' '}
              <span className={classes.unitHeaderText}>
                {unit.unitCount} {unit.packageTypeId}
              </span>
            </div>
          </Grid>
          <Grid item xs={2} className={classes.unitFont}>
            <div>Dimensions:</div>
            <div className={classes.topMargin5}>
              {unit.dimensionInfo.length}
              {UNIT_ABBREVIATIONS[unit.dimensionInfo.dimensionUnit]} x{' '}
              {unit.dimensionInfo.width}
              {UNIT_ABBREVIATIONS[unit.dimensionInfo.dimensionUnit]} x{' '}
              {unit.dimensionInfo.height}
              {UNIT_ABBREVIATIONS[unit.dimensionInfo.dimensionUnit]}
            </div>
          </Grid>
          <Grid item xs={1} className={classes.unitFont}>
            <div>{t('Class')}: </div>
            <div className={classes.topMargin5}>
              {unit.freightInfo.freightClassName}
            </div>
          </Grid>
          <Grid item xs={2} className={classes.unitFont}>
            <div>
              {t('Density')}:
              <div className={classes.topMargin2}>
                {unit.density.toFixed(2)} {UNIT_ABBREVIATIONS[unit.densityUnit]}
                <sup>3</sup>
              </div>
            </div>
          </Grid>
          <Grid item xs={1} className={classes.unitFont}>
            {t('Stackable')}
            <div className={classes.topMargin2}>
              <input type="checkbox" disabled={true} checked={isStackable} />
            </div>
          </Grid>
          <Grid item xs={2} className={classes.unitFont}>
            {t('HazMat')}
            <div className={classes.topMargin2}>
              <input type="checkbox" disabled={true} checked={unitIsHazMat} />
            </div>
          </Grid>
          <Grid item xs={1} className={classes.unitFont}>
            <div>{t('Unit wt.')}</div>
            <div className={classes.topMargin5}>
              {unit.actualWeightInfo.weight}{' '}
              {UNIT_ABBREVIATIONS[unit.actualWeightInfo.weightUnit]}
            </div>
          </Grid>
          <Grid item xs={1} className={classes.unitFont}>
            <div>{t('Tot Value')}</div>
            <div className={classes.topMargin5}>
              {CURRENCY_SYMBOL[unit.currency]}
              {unit.value}
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={8} className={classes.unitBorder}>
          <Grid item xs={12}>
            <table className={classnames(classes.bolTable, classes.bolFont)}>
              <thead>
                <tr className={classes.tableHeader}>
                  <th width="12%">SKU</th>
                  <th width="5%">Qty</th>
                  <th width="15%">Name</th>
                  <th width="5%">Class</th>
                  <th width="10%">NMFC</th>
                  <th width="10%">Pkg Type</th>
                  <th width="5%">HM</th>
                  <th width="20%">
                    {t('Basic Information')}
                    <div className={classes.tinyFont}>
                      {t('Proper Shipping Name')}, {t('Hazard Class')},{' '}
                      {t('ID')} # (UN or NA), {t('Packing Group')}
                    </div>
                  </th>
                  <th width="7%">Weight</th>
                  <th width="6%">Value</th>
                </tr>
              </thead>
              <tbody>
                {unit.shipmentItems.map((item, index) => {
                  return <BOLItemInfo key={index} item={item} />;
                })}
              </tbody>
            </table>
          </Grid>
        </Grid>

        <p />
      </Fragment>
    );
  }
}

UnitInfo.contextType = AppContext;
const translatedUnitInfo = withNamespaces()(UnitInfo);
export default withStyles(
  combineStyles(
    BOLStyles,
    FormItemContainerStyles,
    TypographyStyles,
    LayoutStyles,
    SpacingStyles
  )
)(translatedUnitInfo);
